/* AlertLevel enum. Allows retrieving values with index or string. 
 * 
 * Example: 
 *          AlertLevel[2]           // "Error"
 *          AlertLevel["Error"]     // 2
 */
var AlertLevel;
(function (AlertLevel) {
    AlertLevel[AlertLevel["Message"] = 0] = "Message";
    AlertLevel[AlertLevel["Warning"] = 1] = "Warning";
    AlertLevel[AlertLevel["Error"] = 2] = "Error";
    AlertLevel[AlertLevel["Prompt"] = 3] = "Prompt";
})(AlertLevel || (AlertLevel = {}));


var AlertViewModel = function () {
    var self = this;

    self.alertLevel = ko.observable(AlertLevel.Error);
    self.title = ko.observable("");
    self.message = ko.observable("");
    self.okText = ko.observable("OK");
    self.cancelText = ko.observable("Cancel");
    self.onOk = self.dismiss;
    self.onCancel = self.dismiss;
    self.defaultButton = ko.observable("ok");
    self.buttonHasFocus = ko.observable(true);
    self.afterDismiss = function () { };

    //#region Computed Observables

    // To prevent potential VM memory leaks in ko.computed (evaluatorFunctionTarget reference to VM), supply an evaluatorFunctionTarget to ko.computed 
    // that has a VM reference internally that we can access in the computed's evaluator function and later null-out when we dispose of the computed observables.
    self.vmComputedContext = { _context: self, getContext: function () { return this._context; } };

    self.alertType = ko.computed(function alertTypeComputedEvaluator() {
        var vmComputedContext = this;
        var self = vmComputedContext.getContext();

        return AlertLevel[self.alertLevel()];

    }, self.vmComputedContext);

    //#endregion

    // Reset default button 
    self.message.subscribe(function (value) {
        if (Cartegraph.Utilities.isNullUndefinedOrEmpty(value))
            this.defaultButton("ok");
    }, self);

    DisposableViewModel.call(self);
};

AlertViewModel.prototype.dismiss = function () {
    this.message("");
    this.onOk = this.dismiss;
    this.onCancel = this.dismiss;
    this.buttonHasFocus(true);
    this.defaultButton("ok");
    if(this.afterDismiss)
        this.afterDismiss();
};

AlertViewModel.prototype.init = function (options) {
    this.title(options.title || "");
    this.okText(options.okText || "");
    this.cancelText(options.cancelText || "");
    this.message(options.message || "");
    this.onOk = options.onOk || this.dismiss;
    this.onCancel = options.onCancel || this.dismiss;
    this.defaultButton(options.defaultButton || "ok");
};

AlertViewModel.prototype.error = function (message, title, ok, cancel) {
    var self = this;

    ok = ok || { ok: "" };
    cancel = cancel || { cancel: "" };

    function showError(opts) {
        self.alertLevel(AlertLevel.Error);
        self.init({
            message: message,
            title: title,
            okText: ok.ok,
            cancelText: cancel.cancel,
            onOk: ok.click,
            onCancel: cancel.click,
            defaultButton: cancel.isDefault ? "cancel" : "ok"
        });
        self.afterDismiss = null;
    }

    if (this.message()) {
        this.afterDismiss = showError;
    } else {
        showError();
    }
    
};

AlertViewModel.prototype.warning = function (message, title, ok, cancel) {
    var self = this;

    ok = ok || { ok: "" };
    cancel = cancel || { cancel: "" };

    function showWarning(opts) {
        self.alertLevel(AlertLevel.Warning);
        self.init({
            message: message,
            title: title,
            okText: ok.ok,
            cancelText: cancel.cancel,
            onOk: ok.click,
            onCancel: cancel.click,
            defaultButton: cancel.isDefault ? "cancel" : "ok"
        });
        self.afterDismiss = null;
    }

    if (this.message())  //if we're already showing a message, queue this one.
    {
        this.afterDismiss = showWarning;
    } else {
        showWarning();
    }
};

AlertViewModel.prototype.prompt = function (message, title, ok, cancel) {
    var self = this;

    ok = ok || { ok: "" };
    cancel = cancel || { cancel: "" };

    function showPrompt(opts) {
        self.alertLevel(AlertLevel.Prompt);
        self.init({
            message: message,
            title: title,
            okText: ok.ok,
            cancelText: cancel.cancel,
            onOk: ok.click,
            onCancel: cancel.click,
            defaultButton: cancel.isDefault ? "cancel" : "ok"
        });
        self.afterDismiss = null;
    }

    if (this.message())  //if we're already showing a message, queue this one.
    {
        this.afterDismiss = showPrompt;

    } else {
        showPrompt();
    }
};

Cartegraph.KOAlert = new AlertViewModel();